var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"base-icon icon-bookmark",attrs:{"width":"64","height":"64","viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"currentColor","d":"M16 8h32v48L32 40 16 56z","fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }